import React from "react";

import { NavLink } from "react-router-dom";
import AuthContext from "../../../../AuthContext";
import mtzApis from "../../../../services";
import PostList from "../../posts/PostList";



const { companyService } = mtzApis;

function CompanyPostSummary({ company }) {
  let [posts, setPosts] = React.useState([]);
  let [postStat, setPostStats] = React.useState(null)
  let [companyOwner, setCompanyOwner] = React.useState();
  const me = React.useContext(AuthContext);

  React.useEffect(() => {
    init();
  }, [company]);

  const init = async () => {
    mtzApis.startSpinningIcon();
    const params = new URLSearchParams();
    let cPosts;
    if (company) {
      params.append("companyIds", company.id);
      params.append("limit", "2");

      cPosts = await companyService.getCompanyPosts(params);
      let cPostStats = await companyService.getCompanyPostStats(new URLSearchParams(`companyIds=${company.id}`))
      if (cPostStats)
        setPostStats(cPostStats);
    }

    mtzApis.stopSpinningIcon();
    if (cPosts) {
      // load postInfo
      cPosts = await loadPostInfo(cPosts);

      setPosts(cPosts);
    };
  }

  const loadPostInfo = async (items) => {
    // get company owner
    if (company && company.ownerId) {
      companyOwner = await companyService.getUserById(company.ownerId);
      setCompanyOwner(companyOwner);
      items = items.map(p => {
        p.owner = companyOwner;
        return p;
      });
    }

    // get companies
    items = items.map(p => {
      p.company = company;
      return p;
    });

    // get owners
    let ownerIds = items.map(p => p.ownerId);
    let users = await companyService.getUsers(new URLSearchParams({ userIds: ownerIds }));
    let userMap = {};
    users.forEach(u => userMap[u.id] = u);
    items.forEach(p => {
      p.owner = userMap[p.ownerId];
    });

    // get imgs
    let pIds = items.map(p => p.id);
    let postFiles = await companyService.getPostFiles(new URLSearchParams({ "postIds": pIds, skip: 0, limit: 1000 }));
    if (postFiles) {
      let fMap = {};
      postFiles.forEach(f => {
        fMap[f.postId] = fMap[f.postId] || [];
        fMap[f.postId].push(f);
      });
      items.forEach(p => p.imgs = fMap[p.id]);
      items.forEach(p => {
        if (!p.imgs || p.imgs.length === 0)
          p.imgs = [];
        p.imgs.forEach(f => f.filePath = companyService.getBackendHost() + f.filePath);
      });
    }

    // get like stats
    let reqs = items.map(p => companyService.getPostLikeStats(new URLSearchParams({ "postIds": p.id })));
    let data = await Promise.allSettled(reqs);
    data = data.map(d => d.value);
    for (let i = 0; i < items.length; i++) {
      items[i].likeStats = data[i];
    }

    // get my like
    reqs = items.map(p => companyService.getPostLikes(new URLSearchParams({ "postIds": p.id, "userIds": me.userId })));
    data = await Promise.allSettled(reqs);
    data = data.map(d => d.value);
    for (let i = 0; i < items.length; i++) {
      items[i].myLike = data[i].length > 0 ? data[i][0] : null;
    }

    // get comment stats
    reqs = items.map(p => companyService.getPostCommentStats(new URLSearchParams({ "postIds": p.id })));
    data = await Promise.allSettled(reqs);
    data = data.map(d => d.value);
    for (let i = 0; i < items.length; i++) {
      items[i].commentStats = data[i];
    }

    return items;
  };



  const onNewPostState = async (post) => {
    if (post.deleted) {
      posts = posts.filter(p => p.id !== post.id);
      setPosts([...posts]);
      return;
    }

    let arr = await loadPostInfo([post]);
    post = arr[0];
    posts = posts.map(p => p.id === post.id ? post : p);
    setPosts([...posts]);
  }

  if (!me || !me.userId)
    return <div>Login required</div>;

  if (!company)
    return <div>Cannot find post company</div>;

  return (
    <div className="mtz-card">
      <PostList posts={posts} onChange={onNewPostState} total={postStat && postStat.all.count} />
      <NavLink className="news-feed-company" style={{ fontWeight: "bold" }} to={`/profile/${company.profileName}/posts`}>
        See all posts
      </NavLink>
    </div >

  );
}

export default CompanyPostSummary;